const StopCircled = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M13.692 14.5h-3.384a.78.78 0 0 1-.576-.232.78.78 0 0 1-.232-.576v-3.384q0-.343.232-.576a.78.78 0 0 1 .576-.232h3.384q.344 0 .576.232a.78.78 0 0 1 .232.576v3.384q0 .344-.232.576a.78.78 0 0 1-.576.232"
    />
  </>
)
export default StopCircled
